import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import { AppShell } from "@components/shell/AppShell";
import { WellExplorer } from "@features/wellExplorer/WellExplorer";
import { WellRecord } from "@features/wellRecord/WellRecord";
import { DailyReport } from "@features/dailyReport/DailyReport";
import { TimeNpt } from "@features/timeNpt/TimeNpt";
import { CostAfe } from "@features/costAfe/CostAfe";
import { Inbox } from "@features/inbox/Inbox";
import { AfeManagement } from "@features/afeManagement/AfeManagement";
import { SavedViews } from "@features/savedViews/SavedViews";
import { Surveys } from "@features/surveys/Surveys";
import { Tubulars } from "@features/tubulars/Tubulars";
import { BhaBit } from "@features/bha/BhaBit";
import { Mud } from "@features/mud/Mud";
import { Hse } from "@features/hse/Hse";
import { Pad } from "@features/pad/Pad";
import { Planner } from "@features/planner/Planner";
import { CatalogAdmin } from "@features/catalogAdmin/CatalogAdmin";
import { AccessControl } from "@features/accessControl/AccessControl";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/wells" replace /> },
      { path: "wells", element: <WellExplorer /> },
      { path: "well", element: <WellRecord /> },
      { path: "daily", element: <DailyReport /> },
      { path: "time-npt", element: <TimeNpt /> },
      { path: "cost-afe", element: <CostAfe /> },
      { path: "afe", element: <AfeManagement /> },
      { path: "bha", element: <BhaBit /> },
      { path: "tubulars", element: <Tubulars /> },
      { path: "mud", element: <Mud /> },
      { path: "hse", element: <Hse /> },
      { path: "surveys", element: <Surveys /> },
      { path: "inbox", element: <Inbox /> },
      { path: "saved", element: <SavedViews /> },
      { path: "pad", element: <Pad /> },
      { path: "planner", element: <Planner /> },
      // Catalog admin (preview) — the screen self-gates to data_admin (§22c); the
      // nav entry is likewise admin-only, so field users have no path in.
      { path: "catalog-admin", element: <CatalogAdmin /> },
      // Access control (ACL) admin — the screen self-gates to acl:manage (§ACL);
      // the nav entry is likewise gated, so non-managers have no path in.
      { path: "acl", element: <AccessControl /> },
      { path: "*", element: <Navigate to="/wells" replace /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
